export default {
  deliveryEmailLogs: []
}
